import {Alert} from 'antd';
import {AlertProps} from 'antd/es/alert';
import React, {FC} from 'react';

import s from './alert-error-message.module.less';

interface IAlertErrorMessageProps {
    message: string | null;
    description?: string;
    type?: AlertProps['type'];
    closable?: boolean;
    closeErrorMessage?: () => void;
}

export const AlertErrorMessage: FC<IAlertErrorMessageProps> = ({
    message,
    description,
    type = 'info',
    closable = true,
    closeErrorMessage,
}: IAlertErrorMessageProps) => {
    if (!message) return null;
    return (
        <Alert
            className={s['form-error-message']}
            message={message}
            description={description}
            type={type}
            showIcon
            closable={closable}
            onClose={closeErrorMessage}
        />
    );
};
